import React from 'react'

import { GridColumn } from '../../components/grid/grid-column.js'
import { Grid } from '../../components/grid/grid.js'

export interface LoadingProps {
    title: string
}

export const Loading = (props: LoadingProps): JSX.Element => (
    <Grid>
        <GridColumn width={['xs-12']}>
            <h1>{props.title}</h1>
        </GridColumn>
    </Grid>
)
